import {
  apiGetSchoolFiles,
  apiCopyAssessmentFile,
  apiGetYearGroups
} from '../../common/api/assessment'

const fetchSchoolFiles = (params, initiator) => ({
  requestPrefix: 'SCHOOL_FILES:FETCH',
  params: { initiator },
  request: () =>
    apiGetSchoolFiles({
      include:
        'assessment_file.details,assessment_file.timestamps,assessment_file.student_type.account,assessment_file.student_type.account.names,assessment_file.contributions,assessment_file.contributors,assessment_file.contributor,assessment_file.account.names,assessment_file.account.avatar,assessment_file.works,assessment_file.work.medium.thumb',
      order: 'desc',
      ...params
    })
})

const copySchoolFile = id => ({
  requestPrefix: 'SCHOOL_FILES:COPY',
  request: () => apiCopyAssessmentFile(id)
})

const resetFilters = () => ({ type: 'SCHOOL_FILES:RESET_FILTERS' })

const setSearchFilters = filters => ({
  type: 'SCHOOL_FILES:SET_SEARCH_FILTERS',
  filters
})

const fetchAgeGroups = () => ({
  requestPrefix: 'SCHOOL_FILES:FETCH_AGE_GROUPS',
  request: () =>
    apiGetYearGroups({
      include: 'year_group.names,year_group.order'
    })
})

export {
  fetchSchoolFiles,
  copySchoolFile,
  resetFilters,
  setSearchFilters,
  fetchAgeGroups
}
